import { render, staticRenderFns } from "./cgzDetail.vue?vue&type=template&id=a30c5660&scoped=true&"
import script from "./cgzDetail.vue?vue&type=script&lang=js&"
export * from "./cgzDetail.vue?vue&type=script&lang=js&"
import style0 from "./cgzDetail.vue?vue&type=style&index=0&id=a30c5660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30c5660",
  null
  
)

export default component.exports